import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [TranslatePipe, FlexLayoutModule, MatIcon, MatButtonModule, MatTooltip],
  selector: 'iot-platform-ui-panel',
  templateUrl: './panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent {
  title = input<string>();
  hasButton = input<boolean>(false);
  hasToolbar = input<boolean>(false);
  buttonTooltip = input<string | undefined>();
  withCustomAction = input<boolean>(false);
  icon = input<string>('add');

  clicked = output<void>();

  onClick() {
    this.clicked.emit();
  }
}
